import React from 'react';
import { useRecoilValue } from 'recoil';
import { toastState } from '../../recoil/toast';
import styled from 'styled-components';

interface CustomToastProps {
  message: string;
  type: string;
}

const CustomToast: React.FC<CustomToastProps> = () => {
  const toast = useRecoilValue(toastState);

  if (!toast.isVisible) {
    return null;
  }

  return (
    <Style>
      <div className="wrap">
        <div className="customToastWrap">
          <div
            className="customToast"
            style={{
              background: toast.type === 'error' ? '#FF3542' : '#4DD2AE',
            }}>
            {toast.type === 'error' ? (
              <img src={`${process.env.PUBLIC_URL}/svg/ic_error.svg`} alt="search" />
            ) : (
              <img src={`${process.env.PUBLIC_URL}/svg/ic_success.svg`} alt="search" />
            )}
            <p className="toastMessage">{toast.message}</p>
          </div>
        </div>
      </div>
    </Style>
  );
};

export default CustomToast;

const Style = styled.div`
  .wrap {
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.5); 
    position: fixed;
    top: 0;
    z-index: 9999999;
  }
  .customToastWrap {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .customToast {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 30px;
    text-align: center;
    border-radius: 50px;
  }
  .toastMessage {
    font-size: 20px;
    margin: 0;
    margin-left: 18px;
    font-weight: 500;
    color: #fff;
  }
`;
